var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBrazil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C9E31",
    d: "M1.389 4.722H18.61v10.556H1.39z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCEA2B",
    d: "M16.395 10.007 9.963 14.07l-6.358-3.989 6.432-4.064z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E50A0",
    d: "M10 12.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.266 11.05q.138-.3.194-.627A3.188 3.188 0 0 0 7.605 9.3q-.081.274-.098.56a3.055 3.055 0 0 1 4.76 1.19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBrazil);
export default __webpack_public_path__ + "static/media/flag-brazil.f5ea9622990e2c0d6ab614adefe9cfe6.svg";
export { ForwardRef as ReactComponent };